export default "__VITE_ASSET__BAP7UReU__"